import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kt-app-services',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent {}
